<template>
	<div id="zpagenav">
		<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
			<freeUserTips :type="4" :bgtype="0"></freeUserTips>
		</el-dialog>
		<nav class="zpagenav">
			<ul class="page-ul">
				<li v-bind:key="index" v-for="(item, index) in pageList" v-bind:class="item.class"
					@click.stop="setPage(item)" v-html="item.html"></li>
			</ul>
			<span class="total" style="display: none;">共 {{ total }} 条</span>
			<P class="jump"><span>到</span><input type="number" v-model="jumppage" class="jumppage" /><span>页</span><span
					@click="jumppagefun()" class="jumppage_btn">确定</span></P>
		</nav>
	</div>
</template>
<script>
export default {
	name: 'zpagenav',
	data() {
		return {
			islogin: false,
			userdata: {},
			jumppage: '',
			isShowFreeUserTips: false
		}
	},
	props: {
		prevHtml: String,
		nextHtml: String,
		page: Number,
		total: Number,
		pageSize: Number,
		maxPage: Number,
	},
	computed: {
		pageList: function () {
			var _this = this,
				pageList = [];
			let pageCount = Math.ceil(_this.total / _this.pageSize);
			let page = _this.page;
			let prevHtml = _this.prevHtml ? _this.prevHtml : '&lt;';
			let nextHtml = _this.nextHtml ? _this.nextHtml : '&gt;';
			let maxPage = _this.maxPage ? _this.maxPage : 9;

			let hasPrev = page > 1;
			let hasNext = page < pageCount;

			//上一页
			pageList.push({
				class: hasPrev ? '' : 'disabled',
				page: hasPrev ? page - 1 : page,
				html: prevHtml
			});

			//首页
			pageList.push({
				class: page == 1 ? 'active' : '',
				page: 1,
				html: 1
			});

			if (this.maxPage > 10) {
				var p0 = 5;
			} else {
				var p0 = Math.floor(maxPage / 2);
			}
			var p1 = 1 + 2 + p0; //首页+省略至少2个页码+中间页面数的一半

			var start, end;
			if (page >= p1) {
				start = page - p0;
				//前置省略号
				pageList.push({
					class: 'dot',
					page: page,
					html: '...'
				});
			} else {
				start = 2;
			}

			var p2 = page + p0;
			if (p2 < pageCount) {
				end = p2;
			} else {
				end = pageCount - 1;
			}

			//页码列表
			for (let i = start; i <= end; i++) {
				pageList.push({
					class: page == i ? 'active' : '',
					page: i,
					html: i
				});
			}

			if (end < pageCount - 1) {
				//后置省略号
				pageList.push({
					class: 'dot',
					page: page,
					html: '...'
				});
			}

			//尾页
			if (pageCount > 1) {
				pageList.push({
					class: page == pageCount ? 'active' : '',
					page: pageCount,
					html: pageCount
				});
			}

			//下一页
			pageList.push({
				class: hasNext ? '' : 'disabled',
				page: hasNext ? page + 1 : page,
				html: nextHtml
			});

			return pageList;
		},
	},
	created() {

	},
	mounted() {
		this.userdata = this.getuseriformation();

	},
	methods: {
		jumppagefun() {
			this.jumppage = this.jumppage - 0;
			if (!this.userdata.token &&  this.jumppage >1 ) {
				this.isShowFreeUserTips = true;
				this.jumppage = '';
				return;
			}
			if (this.jumppage != this.page && this.jumppage != 0) {  //jumppge=0 用户输入为空
				this.$emit('pagehandler', this.jumppage);
				// console.log('serpage');
				document.documentElement.scrollTop = 0;
			}

		},
		setPage: function (item) {
			if (!this.userdata.token && item.page >1 ) {
				this.isShowFreeUserTips = true;
				return;
			}
			console.log(item);
			if (item.class == '') {
				this.$emit('pagehandler', item.page);
				// console.log('serpage');
				document.documentElement.scrollTop = 0;
			}
		},
		backTop() {
			const that = this
			document.documentElement.scrollTop = 0;
			// let timer = setInterval(() => {
			// 		let ispeed = Math.floor(-that.scrollTop / 5)
			// 		document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
			// 		if (that.scrollTop === 0) {
			// 				clearInterval(timer)	
			// 		}
			// }, 16)
		},
	},
	
}



</script>

<style>
.jump {
	display: inline-block;
	margin-left: 20px;
	font-size: 14px;
}

.jumppage {
	border: 1px solid #EEEEEE;
	width: 50px;
	height: 30px;
	margin: 0px 10px;
	border-radius: 4px;
	text-align: center;
}

.jumppage_btn {
	cursor: pointer;
	display: inline-block;
	width: 70px;
	height: 30px;
	background-color: #3e7bfa;
	border-radius: 4px;
	color: #ffffff;
	line-height: 30px;
	margin-left: 10px;
}
</style>
